import { Base } from '@studiometa/js-toolkit';
import Cookies from 'js-cookie';

/**
 * Homepage class.
 */
export default class SidebarRight extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'SidebarRight',
    emits: ['change-list'],
    refs: ['display', 'list', 'grid'],
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    this.display = 'grid';
  }

  /**
   * Click on grid listing
   * @returns {void}
   */
  onGridClick() {
    this.$refs.display.classList.remove('display--list');
    this.fetchProjects('grid');
  }

  /**
   * Click on list listing
   * @returns {void}
   */
  onListClick() {
    this.$refs.display.classList.add('display--list');
    this.fetchProjects('list');
  }

  /**
   * Fetch new view
   * @param  {string} template template to load
   * @returns {void}
   */
  fetchProjects(template) {
    if (this.template === template) return;

    this.template = template;
    Cookies.set('layout', template);

    fetch('/wp/wp-admin/admin-ajax.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `action=change_listing&security=custom_nonce&template=${template}`,
    })
      .then((response) => response.json())
      .then((response) => {
        this.$emit('change-list', template, response.data);
      });
  }
}
